import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "download",
  "use": "download-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"download\"><g fill=\"none\" fill-rule=\"evenodd\"><rect fill=\"#FFFE54\" width=\"40\" height=\"40\" rx=\"1.538\" /><path fill=\"#000\" fill-rule=\"nonzero\" d=\"M31 31.5H9v1h22zM19.5 8v18h1V8z\" /><path fill=\"#000\" fill-rule=\"nonzero\" d=\"M11.868 17.646l-.707.708L20 27.192l8.496-8.495-.707-.707L20 25.778z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol